// State
import { createFeatureSelector } from '@ngrx/store';
import { HydratedState } from '../reducers/hydrated.reducer';

export const getHydratedState = createFeatureSelector<HydratedState>('hydrated');
